import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-level",
  "use": "icon-level-usage",
  "viewBox": "0 0 13 3",
  "content": "<symbol viewBox=\"0 0 13 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-level\">\n<rect id=\"icon-level_Rectangle 34624829\" width=\"13\" height=\"3\" rx=\"1.5\" fill=\"#FF7F22\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol